import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly documentTitle = inject(Title);
  private readonly translate = inject(TranslateService);
  private activeTitleKey: string | undefined;

  constructor() {
    super();
    merge(this.translate.onLangChange, this.translate.onTranslationChange).subscribe(() => {
      this.applyTitle();
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.activeTitleKey = this.buildTitle(snapshot);
    this.applyTitle();
  }

  private applyTitle(): void {
    if (!this.activeTitleKey) {
      this.documentTitle.setTitle('Vapt');
      return;
    }

    const translatedTitle = this.translate.instant(this.activeTitleKey);
    const title = typeof translatedTitle === 'string' && translatedTitle !== this.activeTitleKey
      ? translatedTitle
      : '';
    this.documentTitle.setTitle(title ? `Vapt - ${title}` : 'Vapt');
  }
}
